"use strict";

var _style = require("styled-jsx/style");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = undefined && undefined.__extends || function () {
    var extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function (d, b) {
        d.__proto__ = b;
    } || function (d, b) {
        for (var p in b) {
            if (b.hasOwnProperty(p)) d[p] = b[p];
        }
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CodeGenerationPopupCode_1 = require("./CodeGenerationPopupCode");
var CodeGenerationPopupHeader_1 = require("./CodeGenerationPopupHeader");
var CodeGenerationPopupEnvironmentChooser_1 = require("./CodeGenerationPopupEnvironmentChooser");
var CodeGenerationPopupClientChooser_1 = require("./CodeGenerationPopupClientChooser");
var constants_1 = require("../constants");
var Modal = require("react-modal");
var CodeGenerationPopup = function (_super) {
    __extends(CodeGenerationPopup, _super);
    function CodeGenerationPopup(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSetClient = function (client) {
            _this.setState({ selectedClient: client });
        };
        _this.handleSetEnvironment = function (env) {
            _this.setState({ selectedEnv: env });
        };
        _this.state = {
            selectedEnv: 'Browser',
            selectedClient: 'lokka'
        };
        return _this;
    }
    CodeGenerationPopup.prototype.render = function () {
        var _a = this.props,
            query = _a.query,
            endpointUrl = _a.endpointUrl;
        var queryActive = Boolean(query) && query.length > 0;
        return React.createElement(
            Modal,
            { isOpen: this.props.isOpen, onRequestClose: this.props.onRequestClose, contentLabel: "Code Generation", style: constants_1.modalStyle },
            React.createElement(_style2.default, {
                styleId: 2190860931,
                css: ".code-generation-popup-wrapper[data-jsx=\"2190860931\"] {max-height: calc(100vh - 50px);}.overflowScroll,\n.code-generation-popup-wrapper[data-jsx=\"2190860931\"] {overflow: scroll;}.buttonShadow,\n.code-generation-popup-wrapper[data-jsx=\"2190860931\"] {box-shadow: 0 1px 3px 0 rgba(0,0,0,.2);}.bgWhite,\n.code-generation-popup[data-jsx=\"2190860931\"] {background-color: #fff;}.br2,\n.code-generation-popup[data-jsx=\"2190860931\"] {border-radius: 2px;}.flex,\n.code-generation-popup[data-jsx=\"2190860931\"],\n.choosers[data-jsx=\"2190860931\"] {display: -ms-flexbox;display: flex;}.flexColumn,\n.code-generation-popup[data-jsx=\"2190860931\"] {-ms-flex-direction: column;flex-direction: column;}.overflowXHidden,\n.code-generation-popup[data-jsx=\"2190860931\"] {overflow-x: hidden;}.flex,\n.code-generation-popup[data-jsx=\"2190860931\"],\n.choosers[data-jsx=\"2190860931\"] {display: -ms-flexbox;display: flex;}.w100,\n.choosers[data-jsx=\"2190860931\"] {width: 100%;}"
            }),
            React.createElement(
                "div",
                { className: "code-generation-popup-wrapper", "data-jsx": 2190860931
                },
                React.createElement(
                    "div",
                    { className: "code-generation-popup", "data-jsx": 2190860931
                    },
                    React.createElement(CodeGenerationPopupHeader_1.default, { queryActive: queryActive }),
                    React.createElement(
                        "div",
                        { className: "choosers", "data-jsx": 2190860931
                        },
                        React.createElement(CodeGenerationPopupEnvironmentChooser_1.default, { environment: this.state.selectedEnv, setEnvironment: this.handleSetEnvironment }),
                        React.createElement(CodeGenerationPopupClientChooser_1.default, { client: this.state.selectedClient, setClient: this.handleSetClient })
                    ),
                    React.createElement(CodeGenerationPopupCode_1.default, { endpointUrl: endpointUrl, query: query, client: this.state.selectedClient, environment: this.state.selectedEnv })
                )
            )
        );
    };
    return CodeGenerationPopup;
}(React.Component);
exports.CodeGenerationPopup = CodeGenerationPopup;


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-graphiql/babelbuild/CodeGenerationPopup/CodeGenerationPopup.js
// module id = ./node_modules/graphcool-graphiql/babelbuild/CodeGenerationPopup/CodeGenerationPopup.js
// module chunks = 0